import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import PhoneNumber from "./PhoneNumber";
import OtpAndPin from "./OtpAndPin";
import httpClient from "../../custom-hooks/httpClient";
import ImageBanner from "../LoginImgBanner";
import logo from "../../images/kegow-color.png";

function ForgotPin() {
  const history = useHistory();

  const [credentials, setCredentials] = useState({
    security_pin: "",
    phone_number: "",
    otp: "",
  });
  const [isRequestingOTP, setIsRequestingOTP] = useState(false);
  const [isSubmittingOtp, setisSubmittingOtp] = useState(false);
  const [stage, setStage] = useState("request-otp"); // "request-otp", "submit-otp"

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleRequestOtp = (e) => {
    e.preventDefault();

    setIsRequestingOTP(true);
    httpClient
      .get(
        `/auth/forgot?phone_number=234${credentials.phone_number.substring(1)}`
      )
      .then(({ status, data }) => {
        setIsRequestingOTP(false);
        if (status === 200) {
          setStage("submit-otp");
        }
      })
      .catch((err) => {
        setIsRequestingOTP(false);
        toast.error(
          err && err.response
            ? err.response.data.message
            : "Error requesting OTP"
        );
      });
  };

  const handleSubmitOtp = (e) => {
    e.preventDefault();
    setisSubmittingOtp(true);
    const data = {
      ...credentials,
      phone_number: `234${credentials.phone_number.substring(1)}`,
    };

    httpClient
      .post(`/reset-security-pin`, data)
      .then(({ status, data }) => {
        setisSubmittingOtp(false);
        if (status === 200) {
toast.success(data.message || "PIN changed successfully");
          history.push("/login");
        }
      })
      .catch((err) => {
        setisSubmittingOtp(false);
        toast.error(
          err && err.response
            ? err.response.data.message
            : "Error submitting OTP"
        );
      });
  };

  return (
    <>
      <section className="login-page row min-vh-100 d-flex mt-6 mt-md-0 flex-row">
        <ImageBanner />

        <div className="d-flex col-12 align-items-center col-md-6">
          <div className="p-7 container me-md-4">
            <img
              className="keg-login-logo mb-6 mb-md-6"
              src={logo}
              alt="kegow-pic"
            />
            <h1 className="mb-0 fw-medium text-primary">Security PIN Reset</h1>

            {stage === "request-otp" && (
              <PhoneNumber
                handleChange={handleChange}
                handleRequestOtp={handleRequestOtp}
                isRequestingOTP={isRequestingOTP}
              />
            )}
            {stage === "submit-otp" && (
              <OtpAndPin
                handleChange={handleChange}
                handleSubmitOtp={handleSubmitOtp}
                isSubmittingOtp={isSubmittingOtp}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default ForgotPin;
